import { useLayoutEffect, useRef, useState } from 'preact/hooks';
import { useControls } from './useControls';

export function useDynamicCSS(defaultCSS: string = '') {
  const { renderSlot } = useControls();
  const insertionPoint = renderSlot || document.body;
  const [css, setCSS] = useState(defaultCSS);
  const styleElementRef = useRef<HTMLStyleElement | null>(null);

  useLayoutEffect(() => {
    styleElementRef.current = document.createElement('style');
    if (!styleElementRef.current) throw new Error('ref?');
    styleElementRef.current.type = 'text/css';
    styleElementRef.current.id = 'useDynamicCSS';
    insertionPoint.appendChild(styleElementRef.current);

    return () => styleElementRef.current && insertionPoint.removeChild(styleElementRef.current);
  }, []);

  useLayoutEffect(() => {
    if (!styleElementRef.current) return;

    const el = styleElementRef.current as any;
    if (el.styleSheet) {
      el.styleSheet.cssText = css;
    } else {
      el.innerHTML = '';
      el.appendChild(document.createTextNode(css));
    }
  }, [styleElementRef.current, css]);

  return setCSS;
}

export function cssBlock(...cssLines: string[]): string {
  return cssLines.join('\n');
}
